// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"109b56de","977":"b8b58932"}[chunkId] + ".chunk.js";
};